/**
 * Planning Me Route
 * 
 * "Mon Planning" - Personal calendar view for the logged-in user.
 */

import { createFileRoute } from '@tanstack/react-router';
import { PersonalPlanningView } from '@features/home-dashboard/planning';

export const Route = createFileRoute('/_app/(dashboard)/planning/me/')({
  staticData: {
    title: 'Mon Planning',
    section: 'Général',
    order: 50,
    showInTab: true,
    showInBreadcrumb: true,
  },
  component: PlanningMeRoute,
});

function PlanningMeRoute() {
  return <PersonalPlanningView />;
}